
import { Button, List, ListItem, ListItemIcon, ListItemText, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Table, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { Edit, Receipt, Delete, Add, FindInPage, Block, CheckCircle } from '@material-ui/icons'
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import { Examiner } from '../../../interfaces/examiner/Examiner';
import DataTable from 'react-data-table-component';
import request from '../../../api';
import EditExaminerDialog from './EditExaminerDialog';
import NewExaminerDialog from './NewExaminerDialog';

interface Props {
    isSuperuser:boolean
}

interface State {
    data: Examiner[] | null
    totalRows: number
    rowsPerPage: number
    page: number
    sortColumn: string
    sortOrder: 'asc' | 'desc',
    searchQuery: string
    editExaminerDialog: Examiner | null
    newExaminerDialog: boolean
    userId: string
    deleteConfirmDialog: Examiner | null
    disableConfirmDialog: Examiner | null
}

export default class ExaminerExaminerList extends React.Component<Props, State> {

    constructor(props:Props) {

        super(props)

        this.state = {
            data: [],
            totalRows: 0,
            rowsPerPage: 10,
            page: 1,
            sortColumn: 'createdAt',
            sortOrder: 'desc',
            searchQuery: '',
            editExaminerDialog: null,
            newExaminerDialog: false,
            userId: '',
            deleteConfirmDialog: null,
            disableConfirmDialog: null
        }
    }

    private getColumns(): any[] {
        const list: any[] = [
            // {
            //     name: 'Timestamp',
            //     selector: 'timestamp',
            //     sortable: true,
            //     cell: (examiner: Examiner) => new Date(examiner.timestamp).toLocaleDateString()
            // },
            {
                name: 'Username',
                selector: 'username',
                sortable: true
            },
        ]
        if (this.props.isSuperuser) {
            list.push({
                name: 'Role',
                selector: (row: Examiner) => row.role ?? '',
                sortable: false
            })
        }
        list.push(
            {
                name: 'Edit',
                cell: (examiner: Examiner) =>
                    <Fragment>
                        {(this.state.userId === examiner.id || this.props.isSuperuser) && <Edit style={{ cursor: 'pointer' }} onClick={() => this.handleEditExaminer(examiner)} />}
                    </Fragment>
            },
        )
        if (this.props.isSuperuser) {
            list.push({
                name: 'Actions',
                cell: (examiner: Examiner) =>
                    <Fragment>
                        {this.props.isSuperuser && this.state.userId != examiner.id && (
                            <Fragment>
                                {examiner.active !== false ? (
                                    <Block style={{ cursor: 'pointer', color: '#ff9800', marginRight: '10px' }} onClick={() => this.handleDisableExaminer(examiner)} titleAccess="Disable" />
                                ) : (
                                    <CheckCircle style={{ cursor: 'pointer', color: '#4caf50', marginRight: '10px' }} onClick={() => this.handleEnableExaminer(examiner)} titleAccess="Enable" />
                                )}
                                <Delete style={{ cursor: 'pointer', color: '#f44336' }} onClick={() => this.handleDeleteExaminer(examiner)} titleAccess="Delete" />
                            </Fragment>
                        )}
                    </Fragment>
            })
        }
        return list
    }

    render() {

        let { data, totalRows, rowsPerPage, page, searchQuery } = this.state

        if (data === null) {
            return <div>Loading...</div>
        }

        return (
            <Fragment>
                {
                    this.state.editExaminerDialog &&
                    <EditExaminerDialog isSuperuser={this.props.isSuperuser} examiner={this.state.editExaminerDialog} onEdit={this.editExaminer} onClose={this.handleCloseEditExaminerDialog} />
                }
                {
                    this.state.newExaminerDialog &&
                    <NewExaminerDialog onCreate={this.createExaminer} onClose={this.handleCloseNewExaminerDialog} />
                }
                {
                    this.state.deleteConfirmDialog &&
                    <Dialog open={true} onClose={this.handleCloseDeleteDialog}>
                      <DialogTitle>Delete Examiner</DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          Are you sure you want to permanently delete examiner "{this.state.deleteConfirmDialog.username}"? This action cannot be undone and will remove the examiner from the database.
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.handleCloseDeleteDialog} color="primary">
                          Cancel
                        </Button>
                        <Button onClick={this.confirmDeleteExaminer} color="secondary" autoFocus>
                          Delete
                        </Button>
                      </DialogActions>
                    </Dialog>
                }
                {
                    this.state.disableConfirmDialog &&
                    <Dialog open={true} onClose={this.handleCloseDisableDialog}>
                      <DialogTitle>Disable Examiner</DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          Are you sure you want to disable examiner "{this.state.disableConfirmDialog.username}"? They will not be able to log in until re-enabled.
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.handleCloseDisableDialog} color="primary">
                          Cancel
                        </Button>
                        <Button onClick={this.confirmDisableExaminer} color="secondary" autoFocus>
                          Disable
                        </Button>
                      </DialogActions>
                    </Dialog>
                }
                {this.props.isSuperuser && (
                    <Fragment>
                        <Button variant="outlined" color="primary" onClick={this.handleCreateExaminer}>
                            New Examiner
                        </Button>
                        <br />
                    </Fragment>
                )}
                <TextField margin="dense"
                           id="searchQuery" label="Search..."
                           fullWidth defaultValue=""
                           onChange={(e) => this.handleFieldChange(e.target.value)}
                />
                <br />
                <DataTable
                    dense
                    columns={this.getColumns()}
                    data={data}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                    sortServer
                    onSort={this.handleSort}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    onChangePage={this.handleChangePage}
                    noHeader
                    highlightOnHover={true}
                />
            </Fragment>
        )
    }

    componentDidMount() {
        this.reload()
    }

    private async reload() {

        let { page, rowsPerPage, sortColumn, sortOrder, searchQuery } = this.state

        let { examiners, total, reqId } = await (
            await request(`/api/examiner/examiners?offset=${(page - 1) * rowsPerPage}&limit=${rowsPerPage}&sortBy=${sortColumn}&order=${sortOrder}&searchQuery=${searchQuery}`)
        ).json()

        this.setState(prevState => ({ ...prevState, data: examiners, totalRows: total, userId: reqId }))
    }

    handleChangeRowsPerPage = async (rowsPerPage: number) => {
        await this.setState(prevState => ({ ...prevState, rowsPerPage }))
        this.reload()
    }

    handleChangePage = async (page: number) => {
        await this.setState(prevState => ({ ...prevState, page }))
        this.reload()
    }

    handleSort = async (column: any, sortDirection: any) => {
        await this.setState(prevState => ({ ...prevState, sortColumn: column.selector, sortOrder: sortDirection }))
        this.reload()
    }

    handleFieldChange = async (searchQuery: string) => {
        await this.setState(prevState => ({ ...prevState, searchQuery }))
        this.reload()
    }

    handleEditExaminer = (examiner: Examiner) => {
        this.setState(prevState => ({ ...prevState, editExaminerDialog: examiner }))
    }

    editExaminer = async (examiner: Examiner) => {
        await request('/api/examiner/examiners/' + examiner.id, {
            method: 'PUT',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(examiner)
        })
        await this.setState(prevState => ({ ...prevState, saving: false }))
        this.setState(prevState => ({ ...prevState, examiner: examiner, editExaminerDialog: null }))
        this.reload()
    }

    handleCloseEditExaminerDialog = () => {
        this.setState(prevState => ({ ...prevState, editExaminerDialog: null }))
    }

    handleCreateExaminer = () => {
        this.setState(prevState => ({ ...prevState, newExaminerDialog: true }))
    }

    createExaminer = async (examiner: Examiner) => {
        console.log(examiner)
        await request(`/api/examiner/examiners`, {
            method: 'POST',
            body: JSON.stringify(examiner),
            headers: { "content-type": "application/json" }
        })
        this.setState(prevState => ({ ...prevState, newExaminerDialog: false }))
        this.reload()
    }

    handleCloseNewExaminerDialog = () => {
        this.setState(prevState => ({ ...prevState, newExaminerDialog: false }))
    }

    handleDeleteExaminer = (examiner: Examiner) => {
        this.setState(prevState => ({ ...prevState, deleteConfirmDialog: examiner }))
    }

    handleCloseDeleteDialog = () => {
        this.setState(prevState => ({ ...prevState, deleteConfirmDialog: null }))
    }

    confirmDeleteExaminer = async () => {
        if (!this.state.deleteConfirmDialog) return

        await request('/api/examiner/examiners/' + this.state.deleteConfirmDialog.id, {
            method: 'DELETE',
            headers: { 'content-type': 'application/json' }
        })

        this.setState(prevState => ({ ...prevState, deleteConfirmDialog: null }))
        this.reload()
    }

    handleDisableExaminer = (examiner: Examiner) => {
        this.setState(prevState => ({ ...prevState, disableConfirmDialog: examiner }))
    }

    handleCloseDisableDialog = () => {
        this.setState(prevState => ({ ...prevState, disableConfirmDialog: null }))
    }

    confirmDisableExaminer = async () => {
        if (!this.state.disableConfirmDialog) return

        await request('/api/examiner/examiners/' + this.state.disableConfirmDialog.id + '/disable', {
            method: 'POST',
            headers: { 'content-type': 'application/json' }
        })

        this.setState(prevState => ({ ...prevState, disableConfirmDialog: null }))
        this.reload()
    }

    handleEnableExaminer = async (examiner: Examiner) => {
        await request('/api/examiner/examiners/' + examiner.id + '/enable', {
            method: 'POST',
            headers: { 'content-type': 'application/json' }
        })

        this.reload()
    }

}
